import { createFileRoute } from '@tanstack/react-router';
import { RoutePlaceholder } from './-components/RoutePlaceholder';

export const Route = createFileRoute('/bookedticket')({
  component: () => (
    <RoutePlaceholder
      icon="mytickets"
      title="Booked ticket"
      description="Look up a ticket booked in a shop."
    />
  ),
});
